// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const SidebarContentTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  margin-top: 0.5rem;
`;
